<template>
  <div>
    <component :is="item.name"
               v-for="(item, index) in items"
               :key="key(item, index)"
               v-bind="item.props"
               @close="() => close(index)"
    />
  </div>
</template>

<script>
import NeedLocation from '@/components/dialogs/NeedLocation';
import OutOfOrderTime from '@/components/dialogs/OutOfOrderTime';
import AreYouLegal from '@/components/dialogs/AreYouLegal';
import OutOfMenuTime from '@/components/dialogs/OutOfMenuTime';
import CanNotDeliver from '@/components/dialogs/CanNotDeliver';
import CanNotPickUp from '@/components/dialogs/CanNotPickUp';

export default {
  name: 'Dialogs',
  components: {
    NeedLocation,
    OutOfOrderTime,
    AreYouLegal,
    OutOfMenuTime,
    CanNotDeliver,
    CanNotPickUp
  },
  computed: {
    route() {
      return this.$route.name;
    },
    items() {
      return this.$store.state.ui.dialogs || [];
    }
  },
  watch: {
    route() {
      this.$store.commit('ui/dialogHide', 'all');
    }
  },
  methods: {
    key({ name }, index) {
      return `${index}-${name}`;
    },
    close(index) {
      this.$store.commit('ui/dialogHide', index);
    }
  }
};
</script>
